import { mainAPI, handleApiError } from "../api";

import {
  ModeratorCommentRequest,
  CommentsRequest,
  CommentResponse,
} from "../types/api/comments";

const path = `/interactions/admin/${process.env.REACT_APP_API_VERSION}/comments`;

// Комментарии модераторов - Создать
export function createModeratorComment(data: ModeratorCommentRequest) {
  return mainAPI.post(`${path}`, data).then(
    (res) => {
      return Promise.resolve(res.data);
    },
    (error) => handleApiError(error)
  );
}

// Комментарии модераторов - Получить список
export function fetchModeratorComments(params: CommentsRequest) {
  const { entity_id, entity_type, ...queryParams } = params;

  return mainAPI
    .get<CommentResponse[]>(`${path}/entity/${entity_type}/${entity_id}`, {
      params: queryParams,
    })
    .then(
      (res) => {
        const countHeader = res.headers["count"];
        return Promise.resolve({
          list: res.data,
          totalCount: countHeader,
        });
      },
      (error) => handleApiError(error)
    );
}
